import ServiceFactory from "../service-factory";
import { FeatureFlagScopeType } from "utilities/enumerations/feature-flag-scope-type";
import ScopedFeatureFlagRecord from "models/view-models/scoped-feature-flag-record";

interface ListQueryParams {
    scopeType: FeatureFlagScopeType;
}

interface UpdateFeatureFlagPathParams {
    name: string;
}

interface ScopedUpdateFeatureFlagBody {
    isEnabled: boolean;
    scopeType: number;
}

const baseEndpoint = "feature-flags/v2";

const listEndpoint = `${baseEndpoint}/scoped`;
const updateEndpoint = `${baseEndpoint}/:name`;
const resourceType = ScopedFeatureFlagRecord;

const ScopedFeatureFlagsService = {
    list: ServiceFactory.list<ScopedFeatureFlagRecord, ListQueryParams>(
        resourceType,
        listEndpoint
    ),
    update: ServiceFactory.patch<
        ScopedFeatureFlagRecord,
        UpdateFeatureFlagPathParams,
        ScopedUpdateFeatureFlagBody
    >(resourceType, updateEndpoint),
};

export default ScopedFeatureFlagsService;
